import { useCallback, useEffect, useState } from "react";
import MonthVolumeAnalysis from "./MonthVolume";
import { getBessCapacitySummary } from "../../../../../../../Rest_api/RestApi";

export default function MonthAnalysis({
  selectedBlock,
  refreshKey,
  setError,
  selectedScenarios,
}: {
  selectedBlock: any[];
  refreshKey: number;
  setError?: any;
  selectedScenarios: Array<{ scenario_id: number; scenario_number: number }>;
}) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any[]>([]);

  const handleFetchData = useCallback(async () => {
    try {
      setLoading(true);

      if (selectedScenarios && selectedScenarios.length > 0) {
        const scenarioIds = selectedScenarios.map((s) => s.scenario_id);
        const res = await getBessCapacitySummary(scenarioIds);
        setData(res);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data", error);
      setError("An error occurred while fetching data.");
    } finally {
      setLoading(false);
    }
  }, [setError, selectedScenarios]);

  useEffect(() => {
    handleFetchData();
  }, [handleFetchData, refreshKey]);

  return (
    <>
      <div className="dash-card border border-[#718EBF1C] bg-white shadow-[rgba(149,157,165,0.2)_0px_8px_24px] w-full !min-h-[100%] rounded-2xl">
        <div className="flex justify-center items-center mb-1">
          <h2 className="chartHeading !text-sm">Scenario-Wise Generation Capacity (MW)</h2>
        </div>
        <MonthVolumeAnalysis loading={loading} data={data} />
      </div>
    </>
  );
}
